var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / UG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-UG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 10.6666667,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#ED1623",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FEE044",
    mask: "url(#mask-2)",
    x: 0,
    y: 2.66666667,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#ED1623",
    mask: "url(#mask-2)",
    x: 0,
    y: 17.3333333,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FEE044",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-220",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 4.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9073486,7.5740153 C12.7744237,7.44109032 12.7708333,7.22916667 12.9073486,7.09265137 L13.0926514,6.90734863 C13.2255763,6.77442365 13.4299576,6.5455424 13.5568963,6.41108322 L13.7068319,6.29231771 C13.8687442,6.31497001 14.1160162,6.24739965 14.296453,6.27637736 L14.4546548,6.39887492 C14.5717457,6.54677222 14.6003068,6.79938635 14.5187117,6.96257656 L14.1479549,7.70409017 C14.0662417,7.8675167 14,8.15462247 14,8.3333334 L14,8.3333334 C14,8.51742832 14.1327197,8.73302656 14.2959099,8.81462164 L15.0374235,9.18537834 C15.20085,9.26709158 15.4379578,9.43795767 15.5655823,9.56558219 L16.4344177,10.4344176 C16.5626853,10.5626852 16.6003068,10.7993863 16.5187117,10.9625765 L16.1479549,11.7040903 C16.0662417,11.8675168 15.8958333,11.8958335 15.759318,11.7593181 L15.5740153,11.5740153 C15.4410903,11.4410903 15.2291667,11.4375 15.0926514,11.5740153 L14.9073486,11.7593181 C14.7744237,11.8922432 14.6666667,12.1546226 14.6666667,12.3333336 L14.6666667,12.3333336 C14.6666667,12.5174285 14.7708333,12.7708335 14.9073486,12.9073488 L15.0926514,13.0926514 C15.2255763,13.2255764 15.1763967,13.3333333 15.003074,13.3333333 L13.6635927,13.3333333 C13.4811955,13.3333333 13.4375,13.2291667 13.5740153,13.0926514 L13.759318,12.9073486 C13.892243,12.7744237 14,12.5120443 14,12.3333333 L14,12.3333333 C14,12.1492384 13.8453776,12 13.6666667,12 L13.6666667,12 C13.4825718,12 13.2291667,12.1041667 13.0926514,12.240682 L12.9073486,12.4259847 C12.7744237,12.5589097 12.5625,12.5625 12.4259847,12.4259847 L12.240682,12.240682 C12.107757,12.107757 12.1041667,11.8958333 12.240682,11.759318 L12.4259847,11.5740153 C12.5589097,11.4410903 12.8093567,11.3333333 13.003123,11.3333333 L13.6635437,11.3333333 C13.8493634,11.3333333 13.8924713,11.2258046 13.7705746,11.1039079 L12.2294254,9.56275876 C12.1027173,9.4360506 12.1046244,9.2287089 12.2322489,9.10108439 L13.1010844,8.23224894 C13.2293519,8.10398139 13.2291667,7.89583333 13.0926514,7.75931803 L12.9073486,7.5740153 Z",
    id: "Rectangle-1723",
    fill: "#262626",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.ba706212c48bf6d4bf3c0c56bf2705c7.svg";
export { ForwardRef as ReactComponent };